import { call, put, takeEvery} from "redux-saga/effects";
import {
  GET_PAGE_OPERATION_LIST_FOR_VALUE_BY_PARAMS,
} from "./actionTypes"

import {

  getPageOperationListForValueByParamsSuccess,
  pageOperationError
  
} from "./actions"

//Include Both Helper File with needed methods
import {
getPageOperationListForValueByParams,

} from "../../../helpers/backend_helper/backend_helper"

// import { toast,Zoom } from "react-toastify";
// import i18n from 'i18n';


function* fetchUserPageOperation({ payload: record }) {
  try {
    const response = yield call(getPageOperationListForValueByParams,record)
    yield put(getPageOperationListForValueByParamsSuccess(response))
  } catch (error) {
    yield put(pageOperationError(error))
  }
}



function* pageOperationManagementSaga() {

    yield takeEvery(GET_PAGE_OPERATION_LIST_FOR_VALUE_BY_PARAMS,fetchUserPageOperation)
}

export default pageOperationManagementSaga
